export const LS_KEY_USER: string = "authUser";
export const LS_KEY_USERS: string = "users";

export const LAYOUTS: { [key: string]: string } = {
  VERTICAL: "vertical",
  HORIZONTAL: "horizontal",
  TWO_COLUMN: "twoColumn",
};

export const SIDEBAR_SIZE: { [key: string]: string } = {
  DEFAULT: "lg",
  COMPACT: "md",
  SMALL: "sm",
};

export const TOP_BAR: { [key: string]: string } = {
  LIGHT: "light",
  DARK: "dark",
};

export const LAYOUT_WIDTH: { [key: string]: string } = {
  FLUID: "fluid",
};

export const SIDEBAR_COLOR: { [key: string]: string } = {
  LIGHT: "light",
  DARK: "dark",
  GRADIENT: "gradient",
  GRADIENT2: "gradient-2",
  GRADIENT3: "gradient-3",
  GRADIENT4: "gradient-4",
};

export const LAYOUT_THEME: { [key: string]: string } = {
  DEFAULT: "default",
  MATERIAL: "material",
  CREATIVE: "creative",
  MINIMAL: "minimal",
  MODERN: "modern",
  INTERACTION: "interaction",
};

export const SITE_THEME = {
  LIGHT: "light",
  DARK: "dark",
  BRAND: "brand",
};

export const LAYOUT_POSITION = {
  FIXED: "fixed",
  SCROLLABLE: "scrollable",
};

export const PRELOADER = {
  ENABLE: "enable",
  DISABLE: "disable",
};

export const DIR = {
  LTR: "ltr",
  RTL: "rtl",
};
